import { Eye } from 'lucide-react';
import { useTheme } from '../../context/ThemeContext';

const ArgusLogo = ({ size = 'md', showText = true, variant = 'default' }) => {
  const { isDarkMode } = useTheme();

  const sizes = {
    sm: { icon: 'w-8 h-8', text: 'text-lg', eye: 'w-4 h-4' },
    md: { icon: 'w-10 h-10', text: 'text-xl', eye: 'w-5 h-5' },
    lg: { icon: 'w-16 h-16', text: 'text-3xl', eye: 'w-8 h-8' },
    xl: { icon: 'w-20 h-20', text: 'text-4xl', eye: 'w-10 h-10' }
  };

  const s = sizes[size];

  const bgColor = variant === 'light' ? 'bg-white/10' : 'bg-gradient-to-br from-blue-600 to-indigo-700';
  const textColor = variant === 'light' ? 'text-white' : isDarkMode ? 'text-white' : 'text-slate-800';

  return (
    <div className="flex items-center gap-3">
      {/* Logo Icon - Stylized Eye within hexagon shape */}
      <div className={`${s.icon} ${bgColor} rounded-xl flex items-center justify-center relative shadow-lg`}>
        {/* Outer ring representing vigilance */}
        <div className="absolute inset-1 border-2 border-white/30 rounded-lg" />
        {/* Central eye icon */}
        <Eye className={`${s.eye} text-white`} strokeWidth={2.5} />
        {/* Small accent dots representing "100 eyes" concept */}
        <div className="absolute top-1 right-1 w-1.5 h-1.5 bg-cyan-400 rounded-full" />
        <div className="absolute bottom-1 left-1 w-1 h-1 bg-cyan-400 rounded-full" />
      </div>

      {showText && (
        <div className="flex flex-col">
          <span className={`${s.text} font-bold tracking-wide ${textColor}`}>
            ARGUS
          </span>
          {(size === 'lg' || size === 'xl') && (
            <span className={`text-sm ${variant === 'light' ? 'text-slate-300' : 'text-slate-500'} -mt-1`}>
              Complete Payment Visibility
            </span>
          )}
        </div>
      )}
    </div>
  );
};

export default ArgusLogo;
